import React, { useState } from 'react'
import {
  Row,
  Col,
  Button,
  Input,
} from 'reactstrap';
import Alert from 'react-s-alert';
import * as MyAPI from '../../../utils/MyAPI'
import { LOCAL_STRAGE_KEY } from '../../../utils/Settings'
import { useDispatch } from "react-redux";
import * as UserActions from '../../../actions/UserActions'

// AccountPasswordUpdateForm
const AccountPasswordUpdateForm = (props) => {

  let [newPassword, setNewPassword] = useState("");
  let [oldPassword, setOldPassword] = useState("");
  let dispatch = useDispatch();

  let _handleOldPasswordChange = (e) => {
    setOldPassword(e.target.value)
  }
  let _handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value)
  }

  // send data to server
  let _onSubmit = async () => {

    try {

      // check parameters
      if (!oldPassword) {
        throw Error("old password is invalid")
      }
      if (!newPassword) {
        throw Error("new password is invalid")
      }

      // sign in with password
      let _results = await MyAPI.updatePassword({
        login_token: props.login_token,
        old_password: oldPassword,
        new_password: newPassword,
      })

      if (_results.status !== 'success') {
        throw Error(_results.message)
      }

      // success
      let token_params = {
        user_info: _results.user_info,
        login_token: _results.login_token,
        createdAt: new Date(),
      }

      // save token
      localStorage.setItem(LOCAL_STRAGE_KEY, JSON.stringify(token_params.login_token))

      dispatch(UserActions.loginWithEmail(token_params))

      // // redirect
      // history.push("/dashboard")

      Alert.success("パスワードを変更しました", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    } catch (err) {
      console.log("err:", err)

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }
  }

  return (

    <div>

      {/* email */}
      <Row style={{
        marginTop: 10,
        marginBottom: 10,
      }}>
        <Col md="3" xs="12" />
        <Col md="6" xs="12" style={{ textAlign: 'left' }}>

          <div className="shadow2dp" style={{
            backgroundColor: '#ffffff',
            padding: 20,
          }}>

          <Row style={{
            marginTop: 10,
            marginBottom: 10,
          }}>
            <Col md="12" xs="12">

              <span>現在のパスワード</span><br/>
              <Input
                type="password"
                style={{width: '100%'}}
                name='oldPassword'
                onChange={_handleOldPasswordChange}
                value={oldPassword}
                placeholder='' />

            </Col>
          </Row>

          <Row style={{
            marginTop: 10,
            marginBottom: 20,
          }}>
            <Col md="12" xs="12">

              <span>新しいパスワード</span><br/>
              <Input
                type="password"
                style={{width: '100%'}}
                name='newPassword'
                onChange={_handleNewPasswordChange}
                value={newPassword}
                placeholder='' />

            </Col>
          </Row>

          <Row style={{
            marginTop: 20,
            marginBottom: 10,
          }}>
            <Col md="12" xs="12">

              <Button
                onClick={_onSubmit}
                color="primary"
                style={{
                  cursor: 'pointer',
                  width: '100%',
                }}>
                パスワードを変更する
              </Button>

            </Col>
          </Row>

        </div>

        </Col>
        <Col md="3" xs="12" />
      </Row>
    </div>
  )
}

export default AccountPasswordUpdateForm
